import { BrowserRouter, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import AppRoutes from './routes';
import ConditionalLayout from './Components/ConditionalLayout';
import SEOHandler from './SEOHandler';
import FloatingNav from './Components/FloatingNav';
import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <ConditionalLayout>
        <SEOHandler />
        <AppRoutes />
      </ConditionalLayout>
      <FloatingNav />
    </BrowserRouter>
  );
}

export default App;